export const initialState = {
    myworkList: [],
    count:0,
    loading: false,
    notify_message: {
        message: "",
        type: "success",
        show: false,
        title: ""
    },
    workListTable: {
        orderType: "",
        page: 1,
        count: 0,

        initialOrderingPatientName: true,
        initialOrderingClaimId: true,
        initialOrderingDos: true,
        initialOrderingBillDate: true,
        initialOrderingCharges: true,
        initialOrderingBalance: true,
    },
    makeInProgressStatus: false,
    claim_id_open_in_new_tab:"",
}